(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/location-buttons.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/location-buttons.js');

'use strict';

const Button = svs.ui.ReactButton;
const {
  PinIcon
} = svs.lyckoplatsen.shared_utils.react.components;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const {
  useGeolocation,
  useHomeLocation,
  useHomeLocationSelfService
} = svs.lyckoplatsen.components.page_play.react.hooks;
const {
  shouldShowPinAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  isMovingAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  useAtomValue
} = jotai;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const LocationButtons = () => {
  const isMoving = useAtomValue(isMovingAtom);
  const shouldShowPin = useAtomValue(shouldShowPinAtom);
  const handleHomeLocation = useHomeLocation();
  const handleHomeLocationSelfService = useHomeLocationSelfService();
  const handleGeolocation = useGeolocation();
  const handleHomeLocationClick = () => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Sök',
      opt_label: CONSTANTS.LOCATION_TYPES.HOME
    });
    if (svs.core.config.data.svsconfig.isSelfService) {
      handleHomeLocationSelfService();
    } else {
      handleHomeLocation();
    }
  };
  const handleGeolocationClick = () => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Sök',
      opt_label: CONSTANTS.LOCATION_TYPES.CURRENT
    });
    handleGeolocation();
  };
  return React.createElement("div", {
    className: "lp-location-buttons"
  }, React.createElement(Button, {
    disabled: isMoving || shouldShowPin,
    onClick: () => handleHomeLocationClick()
  }, isSelfService ? 'Spela på min hemadress ' : 'Min hemadress ', " ", React.createElement(PinIcon, {
    color: "black"
  })), !isSelfService && React.createElement(Button, {
    disabled: isMoving || shouldShowPin,
    onClick: () => handleGeolocationClick()
  }, "Min position ", React.createElement(PinIcon, {
    color: "black"
  })));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  LocationButtons
});

 })(window);